import {ReportData} from "../../../reports/report.data";

export class OptInMarketingReportData extends ReportData<OptInMarketingReportData> {
}
